import { useCallback, useEffect, useState } from "react";
import { useQuery } from "react-query";

import { UsersService } from "~/entity/Users/api/service";

const PAGE_SIZE = 20;

export function useAvailableRegionalManagers(userId?: number) {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1); // API 1-indexed
  const [items, setItems] = useState<
    Awaited<ReturnType<typeof UsersService.GET.getAvailableRegionalManagers>>["data"]["items"]
  >([]);

  const { data, isLoading } = useQuery(
    ["availableRegionalManagers", userId, search, page],
    () =>
      UsersService.GET.getAvailableRegionalManagers({
        userId,
        search: search || undefined,
        page,
        limit: PAGE_SIZE,
      }).then((res) => res.data),
    { keepPreviousData: true }
  );

  const totalPages = data?.totalPages ?? 1;

  // Накапливаем items по страницам: page 1 — заменяем (новый поиск/сброс),
  // page > 1 — дополняем без дублей по id.
  useEffect(() => {
    const pageItems = data?.items ?? [];
    if (pageItems.length === 0) return;
    if (page === 1) {
      setItems(pageItems);
    } else {
      setItems((prev) => {
        const seen = new Set(prev.map((m) => m.id));
        return [...prev, ...pageItems.filter((m) => !seen.has(m.id))];
      });
    }
  }, [data, page]);

  const onSearch = useCallback((value: string) => {
    setSearch(value);
    setPage(1);
  }, []);

  const onPopupScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const el = e.currentTarget;
      if (
        el.scrollTop + el.clientHeight >= el.scrollHeight - 20 &&
        !isLoading &&
        page < totalPages
      ) {
        setPage((p) => p + 1);
      }
    },
    [isLoading, page, totalPages]
  );

  return { items, isLoading, onSearch, onPopupScroll };
}
